'use client';

import { APPLICATION_STORAGE_KEY } from '@/components/features/Applications/ApplicationForm/ApplicationForm.utils';
import { Link, toast } from '@onbeam/business-ui';
import { TooltipIcon } from '@onbeam/icons/business';
import { isBrowser } from '@onbeam/utils';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

export const FormProgressToast = () => {
  const hasFired = useRef(false); // Only once per visit
  const pathname = usePathname();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Only once
  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (!hasFired.current && !pathname.startsWith('/apply') && isBrowser) {
      const savedProgress = localStorage.getItem(APPLICATION_STORAGE_KEY);
      if (savedProgress) {
        hasFired.current = true;
        timeout = setTimeout(() => {
          toast.message('Application in progress', {
            description: (
              <Link href="/apply">Continue where you left off.</Link>
            ),
            icon: <TooltipIcon />,
          });
        }, 1000);
      }
    }

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return null;
};
